
<template>
	<EagleTap version="advance" :tapContext="tapContext" />
</template>
<script>
import EagleTap from './EagleTap'
import { appSale } from '../../baseData'

export default {
	data () {
		return {
			tapContext: appSale.advanced
		}
	},
	components: {
		EagleTap
	}
}
</script>
